import { Dispatch } from "redux"
import { ActionType } from "../action-types"
import { Action } from "../actions/index"

export const langValueState = (langValue: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LANG_VALUE,
            payload: langValue
        })
    }
}

export const freezScreenState = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_FREEZ_SCREEN,
            payload: mode
        })
    }
}

export const alertMessageState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_ALERT_MESSAGE,
            payload: data
        })
    }
}

export const alertHideState = (mode: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_ALERT_MESSAGE,
            payload: mode
        })
    }
}

export const formDataState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_FORMDATA,
            payload: data
        })
    }
}

export const shopUrlState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_SHOP_URL,
            payload: data
        })
    }
}
export const userInfoState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type : ActionType.SET_USER_INFO,
            payload: data
        })
    }
}